<div
  class="flex flex-row items-center py-2 px-3 bg-gray-50 rounded-full gap-2 text-black font-semibold text-sm"
>
  <span class="truncate max-w-[180px] sm:max-w-max">{{ text }}</span>
  <button type="button" class="group" (click)="removeBadge()">
    <i class="icon-close text-gray-700 text-xs group-hover:text-black"></i>
  </button>
</div>
